module.exports = __webpack_public_path__ + "img/tuv_logo.73b69bba.png";